import { useClearRefinements } from "react-instantsearch-hooks-web";

export const ShowAllButton = ({ setShowMobileFilters }) => {
  const { canRefine, refine } = useClearRefinements({ excludedAttributes: [] });
  const showAll = () => {
    refine("");
    setShowMobileFilters(false);
  };

  return (
    <button
      className="ais-RefinementList-showMore m-0 mb-3 block disabled:hidden"
      disabled={!canRefine}
      onClick={showAll}
    >
      Show All
    </button>
  );
};
